<section class="main-section">
  <nav aria-label="breadcrumb">
    <ol class="breadcrumb">
      <li class="breadcrumb-item"><a routerLink="/admin/adminDashboard/">Home</a></li>
      <li class="breadcrumb-item"><a routerLink="/admin/adminCarriers/">Carriers</a></li>
      <li class="breadcrumb-item active" aria-current="page">Create Carrier</li>
    </ol>
  </nav>
  <div class="row mt-3">
    <div class="col">
      <div class="inner-box connect-bg3">
        <h2 class="text-black mt-3 mb-5">Create your Carrier</h2>
        <div class="market-place-box market-place-box2 market-place-box3">

          <div class="place-box">
            <figure><img src="assets/images/shift_carriers.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button routerLink="/admin/adminShiftDeliveryCreate/1" type="button" class="btn btn-orange mt-2">Connect</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/blue-dart.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button routerLink="/admin/adminBluedartCreate/2" type="button" class="btn btn-orange mt-2">Connect</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/shadowfax.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button routerLink="/admin/adminShadowFaxCreate/3" type="button" class="btn btn-orange mt-2">Connect</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/delhivery-courier.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" routerLink="/admin/adminDelhiveryCreate/4" class="btn btn-orange mt-2">Connect</button>
          </div>

          <!-- <div class="place-box">
             <figure><img src="assets/images/dhl.png"></figure>
             <p>Create your carrier , stay updated with delivery </p>
             <button type="button" class="btn btn-orange mt-2" disabled >Coming soon</button>
           </div>-->

          <div class="place-box">
            <figure><img src="assets/images/fedex.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" routerLink="/admin/adminFedExCreate/5">Connect</button>
          </div>

          <!-- <div class="place-box">
             <figure><img src="assets/images/first-flight-couriers.png"></figure>
             <p>Create your carrier , stay updated with delivery </p>
             <button type="button" class="btn btn-orange mt-2" disabadminOrderled routerLink="/admin/woocommerceUser/7" >Coming soon</button>
           </div>-->

          <div class="place-box">
            <figure><img src="assets/images/Dotzot.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" routerLink="/admin/adminDotzotCreate/6">Connect</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/Gati.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" routerLink="/admin/adminGatiCreate/7">Connect</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/dunzo.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2"  routerLink="/admin/adminDunzoCreate/8">Connect
            </button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/wefast.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2"  routerLink="/admin/adminWeFastCreate/9">Connect
            </button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/pickrr.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2"  routerLink="/admin/adminPickrrCreate/10">Connect
            </button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/shipyaari.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" routerLink="/admin/adminShipyaariCreate/11">Connect</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/Shippigo.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" routerLink="/admin/adminShippigoCreate/12">Connect</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/Vamaship.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" routerLink="/admin/adminVamaShipCreate/13">Connect</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/blowhorn.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/14">Coming soon</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/Afl.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/Clickpost.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/Gojavas.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/Holisol.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/Ithink.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/Kerryindevexpress.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/Onlineexpress.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/Quantium.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/Redexpress.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/Sequel.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/Shipdelight.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/Shyplite.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/Tp-couriers.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/dhl.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/Indiapostal.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/Shipdroid.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2" disabled routerLink="/admin/woocommerceUser/7">Coming soon</button>
          </div>

          <div class="place-box">
            <figure><img src="assets/images/rdlogo.png"></figure>
            <p>Create your carrier , stay updated with delivery </p>
            <button type="button" class="btn btn-orange mt-2"  routerLink="/admin/rapidDeliveryCreate/6" disabled>Coming soon
            </button>
          </div>

        </div>
      </div>
    </div>
  </div>

</section>
